
export class UploadedSheetInfo {
    sheetName: string;
    rowsCount: number;
}